import { makeApiRequest } from '../../utils/api-utils';

// Curated Content Services
export const getAllCuratedContents = async () => makeApiRequest('/curated-content/get-all');
export const getCuratedContentById = async (id: string) => makeApiRequest(`/curated-content/get-by-id/${id}`);

export const createCuratedContent = async (data: any) => makeApiRequest('/curated-content/create', { 
  method: 'POST', 
  body: JSON.stringify(data) 
});

export const updateCuratedContent = async (data: any) => makeApiRequest('/curated-content/update', { 
  method: 'PUT', 
  body: JSON.stringify(data) 
});

export const deleteCuratedContent = async (id: string) => makeApiRequest(`/curated-content/delete/${id}`, { 
  method: 'DELETE' 
});
